export default {
  c1: '布置',
  c2: '换装',
  c3: '人物',
  c4: '保存',
  c5: '所有分类',
  c6: '墙纸',
  c7: '地板',
  c8: '窗⼾',
  c9: '挂饰',
  c10: '运动器材',
  c11: '植物',
  c12: '电视',
  c13: '沙发',
  c14: '茶几',
  c15: '落地灯',
  c16: '镜子',
  c17: '活动限定',
  c18: '保存成功',
  c19: '请重试',
  c20: '布置未保存',
  c21: '当前布置内容尚未保存，离开后不会保留，是否要保存当前已拥有内容？',
  c22: '直接离开',
  c23: '保存已有',
  c24: '活动专属',
  c25: '简介',
  c26: '获取途径',
  c27: '去获取',
  c28: '返回首页',
  c29: '保存成功',
  c30: '请重试',
  c31: '跳过',
  c32: '点击换上您喜欢的服装',
  c33: '点击切换人物/换装/布置玩法',
  c34: '下一步',
  c35: '我知道了',
  c36: '点击选择您想要的分类',
  c37: '点击换上您喜欢的样式/物品',
  c38: "装扮完成后记得点击",
  c39: '「保存」',
  c40: "噢",
  c41:'点击选择您的基础形象',
  c42:'套装',
  c43:'形象',
  c44:'保存中，请稍候…',
  c45:'风景',
  c46:'圣诞摆设',
  c47:'圣诞挂饰',
  c48:'个性功能',
  c49:'您已在新版本更新个人装扮，请升级体验最新功能哦',
  c50:'个性装扮',
  c51:'主题界面',
  c52:'头像挂饰',
  c53:'空间布置',
  c50_1:'虚拟形象，随心换',
  c51_1:'个性主题，探索可能',
  c52_1:'个性挂饰，海量享',
  c53_1:'我的世界，我做主',
  c54:'提示',
  c55:'进入该功能，将会进入MyLink元宇宙，您确定继续吗？',
  c56:'取消',
  c57:'确认',
  c58:'https://mylink.oss-accelerate.aliyuncs.com/myHomeIcon/smallIcon1SC.png'
}
